import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=7516d606&scoped=true"
import script from "./Cards.vue?vue&type=script&lang=js"
export * from "./Cards.vue?vue&type=script&lang=js"
import style0 from "./Cards.vue?vue&type=style&index=0&id=7516d606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7516d606",
  null
  
)

export default component.exports